import { useState } from 'react'
import type { CategoryId } from '../game/types'
import { Game } from './Game'

/**
 * Endless / practice mode: unlimited non-daily puzzles. Remounts Game on each
 * round (keyed by nonce) for a clean reset; tracks how many were solved.
 */
export function Endless({
  category = 'mixed',
  onBack,
}: {
  category?: CategoryId
  onBack: () => void
}) {
  const [nonce, setNonce] = useState(0)
  const [solved, setSolved] = useState(0)

  return (
    <Game
      key={nonce}
      mode="endless"
      category={category}
      nonce={nonce}
      solvedCount={solved}
      onBack={onBack}
      onNext={(won) => {
        if (won) setSolved((s) => s + 1)
        setNonce((n) => n + 1)
      }}
    />
  )
}
